import { createDestinationDetailsQuery } from '@hcr/api/optimizely'

import { HTTP_CONFIG } from '../../../../configs'

export const useDestinationDetailsQuery = createDestinationDetailsQuery(HTTP_CONFIG.API.Optimizely.url)
